import { Subheader as defaultSubheader, styled } from '@streem/ui-react';

export const Subheader = styled(defaultSubheader)`
    margin-bottom: 8px;
    line-height: 25px;
`;
